import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=21f07e8e&scoped=true"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=21f07e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f07e8e",
  null
  
)

export default component.exports